import clsx from 'clsx';
import { FacebookIcon } from './FacebookIcon';
import { LinkedInIcon } from './LinkedInIcon';
import { XIcon } from './XIcon';

import './BlogArticleSocialShareWidget.scss';

const ICONS: {
  icon: () => React.JSX.Element;
  message: string;
  urlPrefix: string;
}[] = [
  {
    icon: XIcon,
    message: 'Share',
    urlPrefix: 'https://x.com/intent/tweet?url=',
  },
  {
    icon: FacebookIcon,
    message: 'Post',
    urlPrefix: 'https://www.facebook.com/sharer/sharer.php?u=',
  },
  {
    icon: LinkedInIcon,
    message: 'LinkedIn',
    urlPrefix: 'https://www.linkedin.com/sharing/share-offsite/?url=',
  },
];

type Props = {
  articleSlug: string;
  mobile?: boolean;
};

export const BlogArticleSocialShareWidget: React.FC<Props> = ({
  mobile = false,
  articleSlug,
}) => (
  <div
    className={clsx('BlogArticleSocialShareWidget', {
      'BlogArticleSocialShareWidget--mobile': mobile,
      'BlogArticleSocialShareWidget--desktop': !mobile,
    })}
  >
    {ICONS.map(({ icon: Icon, message, urlPrefix }, index) => (
      <a
        href={`${urlPrefix}${encodeURI(`${process.env.NEXT_PUBLIC_APP_URL}/blog/${articleSlug}`)}`}
        key={index}
        rel='noopener'
        target='_blank'
      >
        <div className='BlogArticleSocialShareWidget__item'>
          <Icon />

          {message}
        </div>
      </a>
    ))}
  </div>
);
